import { render, staticRenderFns } from "./SectionsTutorialDialog.vue?vue&type=template&id=4a298abe"
import script from "./SectionsTutorialDialog.vue?vue&type=script&lang=js"
export * from "./SectionsTutorialDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports